import TextBookSortManageList from "@/pages/comp/book_order/textbook_sort/common/manage_list";

function TextBookSortManagePopup(props: any) {
  let myProps = {
    listOpt: {},
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <TextBookSortManageList
        listOpt={myProps.listOpt}
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
      ></TextBookSortManageList>
    </div>
  );
};
export default TextBookSortManagePopup;